export class PublicOfferExtraInfos {
  id?:number;
  label?:string;
  value?:string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/publicOfferExtraInfos.ts